import { s as _, r as y, a as u, b as K, c as C, g, p as b } from "./tokens-C4KyVSzL.js";
import { A as W, I as $, R as V, S as X, d as j, e as q, f as G } from "./tokens-C4KyVSzL.js";
import A from "keycloak-js";
import { h as x } from "./oauth-callback-D1dy1GrA.js";
const P = 60 * 1e3, U = 300;
function D(n) {
  var E;
  _(n.appStorageKey);
  const S = {
    realm: n.realm,
    clientId: n.clientId,
    url: n.url
  }, t = new A(S), f = (E = n.scope) != null ? E : "openid profile email";
  let i = null, s = !1, l = null, a = null;
  const T = () => {
    u(t.token, t.refreshToken, t.idToken);
  }, h = () => {
    l && (clearTimeout(l), l = null);
  }, c = () => {
    s = !1, h(), a && (document.removeEventListener("visibilitychange", a), a = null);
  }, w = () => {
    var r, R;
    const e = (r = t.tokenParsed) == null ? void 0 : r.exp;
    if (typeof e == "number")
      return e * 1e3;
    const o = (R = t.token) != null ? R : g();
    if (!o)
      return null;
    try {
      return b(o).exp * 1e3;
    } catch {
      return null;
    }
  }, m = () => {
    if (h(), !s)
      return;
    const e = w();
    if (!e)
      return;
    const o = Math.max(0, e - Date.now() - P);
    l = setTimeout(() => {
      k().then((r) => {
        r || c();
      });
    }, o);
  }, I = async () => {
    try {
      await t.updateToken(U);
      const { token: e, refreshToken: o, idToken: r } = t;
      if (!e)
        throw new Error("Token is undefined after updateToken");
      return u(e, o, r), s && m(), e;
    } catch (e) {
      console.error(e);
      return;
    }
  }, k = () => i || (i = I().finally(() => {
    i = null;
  }), i), d = () => {
    c(), s = !0, m(), a = () => {
      document.visibilityState !== "visible" || !s || k().then((e) => {
        e || c();
      });
    }, document.addEventListener("visibilitychange", a);
  }, p = async () => {
    c(), y(), await t.login();
  }, v = () => x() ? (y(), {}) : {
    token: g() || void 0,
    refreshToken: C() || void 0,
    idToken: K() || void 0
  };
  return {
    init: async () => {
      if (t.didInitialize)
        return;
      const e = v();
      await t.init({
        flow: "standard",
        scope: f,
        token: e.token,
        refreshToken: e.refreshToken,
        idToken: e.idToken,
        messageReceiveTimeout: n.messageReceiveTimeout
      }), t.authenticated && t.token && (T(), d());
    },
    initWithCheckSso: async () => {
      var e;
      if (!t.didInitialize) {
        const o = v();
        await t.init({
          flow: "standard",
          onLoad: "check-sso",
          silentCheckSsoRedirectUri: (e = n.silentCheckSsoRedirectUri) != null ? e : `${window.location.origin}/silent-check-sso.html`,
          pkceMethod: "S256",
          scope: f,
          token: o.token,
          refreshToken: o.refreshToken,
          idToken: o.idToken,
          messageReceiveTimeout: n.messageReceiveTimeout
        });
      }
      if (t.authenticated && t.token)
        return T(), d(), t.authenticated;
      if (t.refreshToken) {
        const o = await k();
        return u(o, t.refreshToken, t.idToken), t.authenticated && o && d(), t.authenticated || !1;
      }
      return await p(), !1;
    },
    updateToken: k,
    login: p,
    logout: async () => {
      var e;
      c(), await t.logout({
        redirectUri: (e = n.postLogoutRedirectUri) != null ? e : `${window.location.origin}/logoff`
      });
    },
    getUserInfo: async (e) => e()
  };
}
export {
  W as ACCESS_TOKEN_KEY,
  $ as ID_TOKEN_KEY,
  V as REFRESH_TOKEN_KEY,
  X as SUB_KEY,
  D as createAuthClient,
  j as decodeToken,
  g as getAccessToken,
  K as getIdToken,
  q as getIsTokenExpired,
  C as getRefreshToken,
  G as getSub,
  x as hasOAuthCallbackParams,
  b as parseToken,
  y as removeTokens,
  _ as setTokenStorageAppKey,
  u as setTokens
};
//# sourceMappingURL=core.es.js.map
